import '@pharmsnap/shared/src/assets/icon-svg/startups.svg'
import { IOrganizationCardInfo } from '@pharmsnap/shared/types'
import { CTRL_C_INFO } from '@pharmsnap/shared/utils'
import { defineComponent, PropType } from '@vue/composition-api'
import { BMicroEntityCard } from '../BMicroEntityCard/BMicroEntityCard'
import $classes from '../EntityCard.module.scss'
import cn from './locales/cn.json'
import en from './locales/en.json'

export const BOrganizationCard = defineComponent({
  name: 'BOrganizationCard',
  i18n: {
    messages: {
      cn,
      en,
    },
  },
  props: {
    data: {
      type: Object as PropType<IOrganizationCardInfo>,
    },
    id: {
      type: String,
      required: true,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {}
  },
  methods: {
    renderContent() {
      return <BMicroEntityCard id={this.id} type="organization" direction={this.direction} data={this.data} onLoaded={() => this.$emit('loaded')} />
    },
  },
  render() {
    return (
      <div class={[$classes.card, CTRL_C_INFO, !this.border && $classes.cardNoBorder]}>
        <div class={$classes.body}>{this.renderContent()}</div>
      </div>
    )
  },
})
